import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { User, Lock, Mail, ArrowRight, Eye, EyeOff } from 'lucide-react';
import { validateCustomerLogin, TEST_CUSTOMER } from '../data/customers';
import './CustomerLogin.css';

function CustomerLogin({ setCustomer }) {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    const user = validateCustomerLogin(email, password);
    if (user) {
      setCustomer(user);
      navigate('/');
    } else {
      setError('Invalid email or password. Please try again.');
    }
  };

  const fillTestCredentials = () => {
    setEmail(TEST_CUSTOMER.email);
    setPassword(TEST_CUSTOMER.password);
    setError('');
  };

  return (
    <div className="customer-login">
      <div className="login-card">
        <div className="login-logo">
          <span className="logo-crescent">☪</span>
          <h1>Welcome Back</h1>
          <p>Sign in to your Bayt Al-Khayr account</p>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="login-form-group">
            <label><Mail size={14} /> Email Address</label>
            <input
              type="email"
              value={email}
              onChange={(e) => { setEmail(e.target.value); setError(''); }}
              placeholder="your@email.com"
              required
            />
          </div>

          <div className="login-form-group">
            <label><Lock size={14} /> Password</label>
            <div className="password-input-wrap">
              <input
                type={showPassword ? 'text' : 'password'}
                value={password}
                onChange={(e) => { setPassword(e.target.value); setError(''); }}
                placeholder="Enter your password"
                required
              />
              <button type="button" className="toggle-password" onClick={() => setShowPassword(!showPassword)}>
                {showPassword ? <EyeOff size={16} /> : <Eye size={16} />}
              </button>
            </div>
          </div>

          {error && <p className="login-error">{error}</p>}

          <button type="submit" className="btn btn-gold login-btn">
            Sign In <ArrowRight size={18} />
          </button>
        </form>

        <div className="test-credentials">
          <p><User size={14} /> Test Account</p>
          <div className="test-info">
            <span>Email: <code>{TEST_CUSTOMER.email}</code></span>
            <span>Password: <code>{TEST_CUSTOMER.password}</code></span>
          </div>
          <button type="button" className="btn-fill-test" onClick={fillTestCredentials}>
            Use Test Credentials
          </button>
        </div>

        <div className="login-footer">
          <Link to="/">← Back to Store</Link>
        </div>
      </div>
    </div>
  );
}

export default CustomerLogin;
